import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Gallery from "@/pages/Gallery";
import Projects from "@/pages/Projects";
import AIStudio from "@/pages/AIStudio";
import Collections from "@/pages/Collections";
import SharedDesign from "@/pages/SharedDesign";
import MaterialCalculator from "@/pages/MaterialCalculator";
import Booking from "@/pages/Booking";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import Handyman from "@/pages/Handyman";
import FAQ from "@/pages/FAQ";
import Reviews from "@/pages/Reviews";
import Legal from "@/pages/Legal";
import StaffPortal from "@/pages/StaffPortal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollTop() {
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/studio" element={<AIStudio />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/ai-studio" element={<Navigate to="/studio" replace />} />
            <Route path="/design/:id" element={<SharedDesign />} />
            <Route path="/calculator" element={<MaterialCalculator />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/handyman" element={<Handyman />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/portal" element={<StaffPortal />} />
            <Route path="/staff" element={<StaffPortal />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
